import { InformationTextAlign } from "../components/InformationCard";
import i18next from "../i18n";
import {
  AnimationAlign,
  ApkInformationAnimationTextAlign,
} from "../pages/Download/component/ApkInformationAnimation";
import DownloadContentInformationSteps from "../pages/Download/component/DownloadContentInformationSteps";
import DownloadInformationLayout from "../pages/Download/component/DownloadInformationLayout";
import AssetsPack from "./AssetsPack";
import { useNavigate } from "react-router-dom";
import { showConsoleWarning } from "./ConsoleMessage";
import { FAQType } from "../pages/Support/component/FAQType";
import { ListData } from "../components/footer/FooterAccordian";
import { AllCardsGames, ParentGames } from "./AllCardsGames";

export const lucky7games = [
  {
    title: i18next.t("lucky7_card.aus_4d.title"),
    URL: `/learn?scrollTo=${AllCardsGames.AUS_4D}`,
    paragraph: i18next.t("lucky7_card.aus_4d.paragraph"),
    srcImage: AssetsPack.image.AUS_4D,
    indicator: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    type: AllCardsGames.AUS_4D,
  },
  {
    title: i18next.t("lucky7_card.lucky_ball.title"),
    URL: `/learn?scrollTo=${AllCardsGames.LUCKY_BALL}`,
    paragraph: i18next.t("lucky7_card.lucky_ball.paragraph"),
    srcImage: AssetsPack.image.LUCKY_BALL,
    indicator: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    type: AllCardsGames.LUCKY_BALL,
  },
  {
    title: i18next.t("lucky7_card.three_ball.title"),
    URL: "#",
    paragraph: i18next.t("lucky7_card.three_ball.paragraph"),
    srcImage: AssetsPack.image.THREE_BALL,
    indicator: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    type: AllCardsGames.THREE_BALL,
  },
  {
    title: i18next.t("lucky7_card.odds_evens.title"),
    URL: "#",
    paragraph: i18next.t("lucky7_card.odds_evens.paragraph"),
    srcImage: AssetsPack.image.EVEN_ODDS,
    indicator: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    type: AllCardsGames.ODDS_EVEN,
  },
  {
    title: i18next.t("lucky7_card.miss_match.title"),
    URL: "#",
    paragraph: i18next.t("lucky7_card.miss_match.paragraph"),
    srcImage: AssetsPack.image.MISS_MATCH,
    indicator: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    type: AllCardsGames.MISS_MATCH,
  },
];

export const fourDgames = [
  {
    title: i18next.t("four_d_games.single_bet.title"),
    URL: "#",
    paragraph: i18next.t("four_d_games.single_bet.paragraph"),
    srcImage: AssetsPack.image.SINGLE_BET,
    indicator: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    type: AllCardsGames.SINGLE_BET,
  },
  {
    title: i18next.t("four_d_games.traditional_bet.title"),
    URL: "#",
    paragraph: i18next.t("four_d_games.traditional_bet.paragraph"),
    srcImage: AssetsPack.image.TRADITIONAL_BET,
    indicator: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    type: AllCardsGames.TRADITIONAL_BET,
  },
  {
    title: i18next.t("four_d_games.probet_ball.title"),
    URL: "#",
    paragraph: i18next.t("four_d_games.probet_ball.paragraph"),
    srcImage: AssetsPack.image.PRO_BET,
    indicator: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    type: AllCardsGames.PRO_BET,
  },
  {
    title: i18next.t("four_d_games.package_bet.title"),
    URL: "#",
    paragraph: i18next.t("four_d_games.package_bet.paragraph"),
    srcImage: AssetsPack.image.PACKAGE_BET,
    indicator: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    type: AllCardsGames.PACKAGE_BET,
  },
];

export const turboScratchs = [
  {
    title: i18next.t("turbo_scratch.scratch_card.title"),
    URL: "#",
    paragraph: i18next.t("turbo_scratch.scratch_card.paragraph"),
    srcImage: AssetsPack.image.TURBO_SCRATCH_1,
    indicator: AssetsPack.videos.TURBO_LIST_INDICATOR,
  },
  {
    title: i18next.t("turbo_scratch.reveal_and_pop.title"),
    URL: "#",
    paragraph: i18next.t("turbo_scratch.reveal_and_pop.paragraph"),
    srcImage: AssetsPack.image.TURBO_SCRATCH_2,
    indicator: AssetsPack.videos.TURBO_LIST_INDICATOR,
  },
  {
    title: i18next.t("turbo_scratch.earn_as_you_win.title"),
    URL: "#",
    paragraph: i18next.t("turbo_scratch.earn_as_you_win.paragraph"),
    srcImage: AssetsPack.image.TURBO_SCRATCH_3,
    indicator: AssetsPack.videos.TURBO_LIST_INDICATOR,
  },
  {
    title: i18next.t("turbo_scratch.double_down.title"),
    URL: "#",
    paragraph: i18next.t("turbo_scratch.double_down.paragraph"),
    srcImage: AssetsPack.image.TURBO_SCRATCH_4,
    indicator: AssetsPack.videos.TURBO_LIST_INDICATOR,
  },
];

export const matchSymbols = [
  {
    title: i18next.t("match_symbols.select_cards.title"),
    URL: "#",
    paragraph: i18next.t("match_symbols.select_cards.paragraph"),
    srcImage: AssetsPack.images.MATCH_SYMBOL_1,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
  },
  {
    title: i18next.t("match_symbols.reveal_symbols.title"),
    URL: "#",
    paragraph: i18next.t("match_symbols.reveal_symbols.paragraph"),
    srcImage: AssetsPack.images.MATCH_SYMBOL_2,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
  },
  {
    title: i18next.t("match_symbols.match_symbols.title"),
    URL: "#",
    paragraph: i18next.t("match_symbols.match_symbols.paragraph"),
    srcImage: AssetsPack.images.MATCH_SYMBOL_3,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
  },
];

export const sugarScratches = [
  {
    title: i18next.t("sugar_scratches.match_symbols.title"),
    URL: "#",
    paragraph: i18next.t("sugar_scratches.match_symbols.paragraph"),
    srcImage: AssetsPack.image.SUGAR_SCRATCH_1,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
  },

  {
    title: i18next.t("sugar_scratches.select_cards.title"),
    URL: "#",
    paragraph: i18next.t("sugar_scratches.select_cards.paragraph"),
    srcImage: AssetsPack.image.SUGAR_SCRATCH_2,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
  },
  {
    title: i18next.t("sugar_scratches.earn_connect.title"),
    URL: "#",
    paragraph: i18next.t("sugar_scratches.earn_connect.paragraph"),
    srcImage: AssetsPack.image.SUGAR_SCRATCH_3,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
  },
];

export const allGameList = [
  lucky7games,
  fourDgames,
  turboScratchs,
  matchSymbols,
  sugarScratches,
];

export const rewardsPromoSettingInfo = [
  {
    title: i18next.t(
      "joker_rewards.setting_promo.information_list.tracked_statistics_title"
    ),
    description: i18next.t(
      "joker_rewards.setting_promo.information_list.tracked_statistics_description"
    ),
  },
  {
    title: i18next.t(
      "joker_rewards.setting_promo.information_list.refer_friends_title"
    ),
    description: i18next.t(
      "joker_rewards.setting_promo.information_list.refer_friends_description"
    ),
  },
  {
    title: i18next.t(
      "joker_rewards.setting_promo.information_list.tier_based_system_title"
    ),
    description: i18next.t(
      "joker_rewards.setting_promo.information_list.tier_based_system_description"
    ),
  },
  {
    title: i18next.t(
      "joker_rewards.setting_promo.information_list.earn_joker_points_title"
    ),
    description: i18next.t(
      "joker_rewards.setting_promo.information_list.earn_joker_points_description"
    ),
  },
];

export const faqCards = [
  {
    label: i18next.t("account"),
    icon: AssetsPack.icons.SUPPORT_ACCOUNT.default,
    type: FAQType.Account,
  },
  {
    label: i18next.t("wallet"),
    icon: AssetsPack.icons.SUPPORT_WALLET.default,
    type: FAQType.Wallet,
  },

  {
    label: i18next.t("lucky_7"),
    icon: AssetsPack.icons.SUPPORT_LUCKY7.default,
    type: FAQType.Lucky7,
  },
  {
    label: i18next.t("four_d"),
    icon: AssetsPack.icons.SUPPORT_4D.default,
    type: FAQType.FourD,
  },
  {
    label: i18next.t("scratch_win"),
    icon: AssetsPack.icons.SUPPORT_SCRATCH.default,
    type: FAQType.ScratchWin,
  },

  {
    label: i18next.t("joker_support.all_faqs"),
    icon: AssetsPack.icons.SUPPORT_ALL_GAMES.default,
    type: FAQType.All,
  },
];

export const rewardInformationSectionItems = () => {
  const navigate = useNavigate();

  return [
    {
      title: i18next.t("joker_rewards.unlock_reward.share_earn_reward"),
      description: i18next.t(
        "joker_rewards.unlock_reward.share_earn_reward_description"
      ),
      buttonName: i18next.t("global_component.create_account"),
      srcImage: AssetsPack.image.REWARDS_PROGRAM_SHARE,
      informationAlignment: InformationTextAlign.Top,
      onClickAction: () => {
        navigate("/sign_up");
      },
      isDisable: true,
    },
    {
      title: i18next.t("joker_rewards.unlock_reward.become_player"),
      description: i18next.t(
        "joker_rewards.unlock_reward.become_player_description"
      ),
      buttonName: i18next.t("global_component.get_started"),
      srcImage: AssetsPack.image.REWARDS_PROGRAM_TOP_PLAYER,
      informationAlignment: InformationTextAlign.Bottom,
      onClickAction: () => {
        navigate("/download");
      },
      isDisable: true,
    },
  ];
};

export const supportButtons = [
  {
    label: i18next.t("joker_support.live_chat"),
    icon: AssetsPack.icons.ICON_LIVECHAT.default,
    href: "",
    isDisable: false,
  },
  {
    label: i18next.t("joker_support.download_apk"),
    icon: AssetsPack.icons.ICON_DOWNLOAD.default,
    href: "/download",
    isDisable: false,
  },
];

export const supportInformationSectionItems = () => {
  const navigate = useNavigate();

  return [
    {
      title: i18next.t("joker_support.simplify_journey.join_game"),
      description: i18next.t(
        "joker_support.simplify_journey.join_game_description"
      ),
      buttonName: i18next.t("global_component.continue"),
      srcImage: AssetsPack.image.SUPPORT_JOIN_GAME,
      informationAlignment: InformationTextAlign.Bottom,
      onClickAction: () => {
        navigate("/sign_up");
      },
      isDisable: true,
    },
    {
      title: i18next.t("joker_support.simplify_journey.tutorial_videos"),
      description: i18next.t(
        "joker_support.simplify_journey.tutorial_videos_description"
      ),
      buttonName: i18next.t("global_component.watch_now"),
      srcImage: AssetsPack.image.SUPPORT_TUTORIAL_VIDEOS,
      informationAlignment: InformationTextAlign.Bottom,
      onClickAction: () => {
        navigate("/learn");
      },
      isDisable: false,
    },
  ];
};

export const lucky7MobileList = [
  {
    title: i18next.t("fourD_components.lucky_7"),
    srcImage: AssetsPack.images.MOBILE_LUCKY7,
    description: i18next.t("lucky7_card.description"),
  },

  {
    title: i18next.t("lucky7_card.aus_4d.title"),
    srcImage: AssetsPack.images.MOBILE_LUCKY7_AUS4D,
    description: i18next.t("lucky7_card.aus_4d.description"),
  },

  {
    title: i18next.t("lucky7_card.lucky_ball.title"),
    srcImage: AssetsPack.images.MOBILE_LUCKY7_LUCKY_BALL,
    description: i18next.t("lucky7_card.lucky_ball.description"),
  },

  {
    title: i18next.t("lucky7_card.three_ball.title"),
    srcImage: AssetsPack.images.MOBILE_LUCKY7_THREE_BALL,
    description: i18next.t("lucky7_card.three_ball.description"),
  },

  {
    title: i18next.t("lucky7_card.odds_evens.title"),
    srcImage: AssetsPack.images.MOBILE_LUCKY7_ODDS_EVEN,
    description: i18next.t("lucky7_card.odds_evens.description"),
  },

  {
    title: i18next.t("lucky7_card.miss_match.title"),
    srcImage: AssetsPack.images.MOBILE_LUCKY7_MISMATCH_BALL,
    description: i18next.t("lucky7_card.miss_match.description"),
  },
];

export const jokerProList = [
  {
    title: i18next.t("fourD_components.lucky_7"),

    description: i18next.t("joker_pro_page.lucky7_description_landscape_card"),
    video: AssetsPack.videos.LANDSCAPE_LUCKY7,
    indicator: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    image: AssetsPack.image.LANDSCAPE_LUCKY7,
    type: ParentGames.LUCKY_7,
  },

  {
    title: i18next.t("fourD_components.4d_lotto"),
    description: i18next.t("joker_pro_page.four_d_description_landscape_card"),
    video: AssetsPack.videos.LANDSCAPE_FOUR_D_CARD,
    indicator: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    image: AssetsPack.image.LANDSCAPE_LOTTO_4D,
    type: ParentGames.LOTTO_4D,
  },
];

export const fourDMobileList = [
  {
    title: i18next.t("fourD_components.4d_lotto"),
    srcImage: AssetsPack.images.MOBILE_FOUR_D_LOTTO,
    description: i18next.t("four_d_games.description"),
  },

  {
    title: i18next.t("four_d_games.single_bet.title"),
    srcImage: AssetsPack.images.MOBILE_FOUR_D_SINGLE_BET,
    description: i18next.t("four_d_games.single_bet.description"),
  },

  {
    title: i18next.t("four_d_games.traditional_bet.title"),
    srcImage: AssetsPack.images.MOBILE_FOUR_D_TRADITIONAL_BET,
    description: i18next.t("four_d_games.traditional_bet.description"),
  },

  {
    title: i18next.t("four_d_games.probet_ball.title"),
    srcImage: AssetsPack.images.MOBILE_FOUR_D_PRO_BET,
    description: i18next.t("four_d_games.probet_ball.description"),
  },

  {
    title: i18next.t("four_d_games.package_bet.title"),
    srcImage: AssetsPack.images.MOBILE_FOUR_D_PACKAGE_BET,
    description: i18next.t("four_d_games.package_bet.description"),
  },
];

export const jokerScratchList = [
  {
    title: i18next.t("turbo_scratch.title"),

    description: i18next.t(
      "joker_scratch_page.turbo_scratch_description_landscape_card"
    ),
    video: AssetsPack.videos.LANDSCAPE_TURBO_SCRATCH,
    image: AssetsPack.image.LANDSCAPE_TURBO_SCRATCH,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
    type: ParentGames.TURBO,
  },
  {
    title: i18next.t("joker_scratch_page.sugar.title"),

    description: i18next.t(
      "joker_scratch_page.sugar_scratch_description_landscape_card"
    ),
    video: AssetsPack.videos.LANDSCAPE_SUGAR_SCRATCH,
    image: AssetsPack.image.LANDSCAPE_SUGAR_SCRATCH,
    indicator: AssetsPack.videos.SUGAR_LIST_INDICATOR,
    type: ParentGames.SUGAR,
  },
];

export const turboScratchMobileList = [
  {
    title: i18next.t("joker_scratch_page.title"),
    srcImage: AssetsPack.images.MOBILE_TURBO_SCRATCH,
    description: i18next.t("joker_scratch_page.description_gsap"),
  },

  {
    title: i18next.t("joker_scratch_page.diverse_theme.title"),
    srcImage: AssetsPack.images.MOBILE_TURBO_SCRATCH_2,
    description: i18next.t("joker_scratch_page.description_gsap_1"),
  },

  {
    title: i18next.t("joker_scratch_page.reveal_and_pop.title"),
    srcImage: AssetsPack.images.MOBILE_TURBO_SCRATCH_3,
    description: i18next.t("joker_scratch_page.description_gsap_2"),
  },

  {
    title: i18next.t("joker_scratch_page.earn_as_you_win.title"),
    srcImage: AssetsPack.images.MOBILE_TURBO_SCRATCH_4,
    description: i18next.t("joker_scratch_page.description_gsap_3"),
  },
];

export const downloadingStepInformationList = [
  {
    video: AssetsPack.videos.DOWNLOAD_STEP_1,
    informationTextAlignment: ApkInformationAnimationTextAlign.Right,
    animationAlignment: AnimationAlign.Top,
    contentInformation: (
      <DownloadInformationLayout
        title={i18next.t("joker_download_page.download_apk_file.title")}
        description={(() => {
          const description = i18next.t(
            "joker_download_page.download_apk_file.description",
            { returnObjects: true }
          );
          if (Array.isArray(description)) {
            return description;
          } else {
            console.warn(
              "Expected description to be an array, but got:",
              description
            );
            return [
              i18next.t("joker_download_page.download_apk_file.description"),
            ];
          }
        })()}
      />
    ),
  },

  {
    video: AssetsPack.videos.DOWNLOAD_STEP_2,
    informationTextAlignment: ApkInformationAnimationTextAlign.Left,
    animationAlignment: AnimationAlign.Top,
    contentInformation: <DownloadContentInformationSteps />,
  },

  {
    video: AssetsPack.videos.DOWNLOAD_STEP_3,
    informationTextAlignment: ApkInformationAnimationTextAlign.Left,
    animationAlignment: AnimationAlign.Bottom,
    contentInformation: (
      <DownloadInformationLayout
        title={i18next.t("joker_download_page.install_the_apk.title")}
        description={(() => {
          const description = i18next.t(
            "joker_download_page.install_the_apk.description",
            { returnObjects: true }
          );
          if (Array.isArray(description)) {
            return description;
          } else {
            console.warn(
              "Expected description to be an array, but got:",
              description
            );
            return [
              i18next.t("joker_download_page.install_the_apk.description"),
            ];
          }
        })()}
      />
    ),
  },

  {
    video: AssetsPack.videos.DOWNLOAD_STEP_4,
    informationTextAlignment: ApkInformationAnimationTextAlign.Right,
    animationAlignment: AnimationAlign.Top,
    contentInformation: (
      <DownloadInformationLayout
        title={i18next.t("joker_download_page.open_app.title")}
        description={(() => {
          const description = i18next.t(
            "joker_download_page.open_app.description",
            { returnObjects: true }
          );
          if (Array.isArray(description)) {
            return description;
          } else {
            console.warn(
              "Expected description to be an array, but got:",
              description
            );
            return [i18next.t("joker_download_page.open_app.description")];
          }
        })()}
      />
    ),
  },
];

export const faqListData = [
  {
    type: FAQType.Account,
    list: (() => {
      const description = i18next.t("joker_support.faq_list.acccount", {
        returnObjects: true,
      });
      if (Array.isArray(description)) {
        return description;
      } else {
        showConsoleWarning("", description);
        return [i18next.t("joker_support.faq_list.acccount")];
      }
    })(),
  },

  {
    type: FAQType.Wallet,
    list: (() => {
      const description = i18next.t("joker_support.faq_list.wallet", {
        returnObjects: true,
      });
      if (Array.isArray(description)) {
        return description;
      } else {
        showConsoleWarning("", description);
        return [i18next.t("joker_support.faq_list.wallet")];
      }
    })(),
  },

  {
    type: FAQType.Lucky7,
    list: (() => {
      const description = i18next.t("joker_support.faq_list.lucky_7", {
        returnObjects: true,
      });
      if (Array.isArray(description)) {
        return description;
      } else {
        showConsoleWarning("", description);
        return [i18next.t("joker_support.faq_list.lucky_7")];
      }
    })(),
  },

  {
    type: FAQType.FourD,
    list: (() => {
      const description = i18next.t("joker_support.faq_list.four_d", {
        returnObjects: true,
      });
      if (Array.isArray(description)) {
        return description;
      } else {
        showConsoleWarning("", description);
        return [i18next.t("joker_support.faq_list.four_d")];
      }
    })(),
  },

  {
    type: FAQType.ScratchWin,
    list: (() => {
      const description = i18next.t("joker_support.faq_list.scratch_win", {
        returnObjects: true,
      });
      if (Array.isArray(description)) {
        return description;
      } else {
        showConsoleWarning("", description);
        return [i18next.t("joker_support.faq_list.scratch_win")];
      }
    })(),
  },
].flatMap((faq) =>
  faq.list.map((item) => ({
    ...item,
    type: faq.type,
  }))
);
export const learnVideoList = [
  {
    id: 1,
    title: i18next.t("joker_learn_page.aus_4d.title"),
    description: i18next.t("joker_learn_page.aus_4d.description"),
    video_url: AssetsPack.tutorial_videos_url.AUS_4D,
    indicatorIcon: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_AUS,
    type: AllCardsGames.AUS_4D,
  },
  {
    id: 2,
    title: i18next.t("joker_learn_page.lucky_ball.title"),
    description: i18next.t("joker_learn_page.lucky_ball.description"),
    video_url: AssetsPack.tutorial_videos_url.LUCKY_BALL,
    indicatorIcon: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_LUCKY_BALL,
    type: AllCardsGames.LUCKY_BALL,
  },
  {
    id: 3,
    title: i18next.t("joker_learn_page.three_ball.title"),
    description: i18next.t("joker_learn_page.three_ball.description"),
    video_url: AssetsPack.tutorial_videos_url.THREE_BALL,
    indicatorIcon: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_THREE_BALL,
    type: AllCardsGames.THREE_BALL,
  },
  {
    id: 4,
    title: i18next.t("joker_learn_page.odds_even.title"),
    description: i18next.t("joker_learn_page.odds_even.description"),
    video_url: AssetsPack.tutorial_videos_url.ODDS_EVEN,
    indicatorIcon: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_ODDS_EVEN,
    type: AllCardsGames.ODDS_EVEN,
  },
  {
    id: 5,
    title: i18next.t("joker_learn_page.miss_match.title"),
    description: i18next.t("joker_learn_page.miss_match.description"),
    video_url: AssetsPack.tutorial_videos_url.MISS_MATCH,
    indicatorIcon: AssetsPack.videos.LUCKY7_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_MISS_MATCH,
    type: AllCardsGames.MISS_MATCH,
  },
  {
    id: 6,
    title: i18next.t("joker_learn_page.single_bet.title"),
    description: i18next.t("joker_learn_page.single_bet.description"),
    video_url: AssetsPack.tutorial_videos_url.SINGLE_BET,
    indicatorIcon: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_SINGLE_BET,
    type: AllCardsGames.SINGLE_BET,
  },
  {
    id: 7,
    title: i18next.t("joker_learn_page.traditional_bet.title"),
    description: i18next.t("joker_learn_page.traditional_bet.description"),
    video_url: AssetsPack.tutorial_videos_url.TRDAITIONAL_BET,
    indicatorIcon: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_TRADITIONAL_BET,
    type: AllCardsGames.TRADITIONAL_BET,
  },
  {
    id: 8,
    title: i18next.t("joker_learn_page.package_bet.title"),
    description: i18next.t("joker_learn_page.package_bet.description"),
    video_url: AssetsPack.tutorial_videos_url.PACKAGE_BET,
    indicatorIcon: AssetsPack.videos.FOUR_D_LIST_INDICATOR,
    posterImg: AssetsPack.image.POSTER_PACKAGE_BET,
    type: AllCardsGames.PACKAGE_BET,
  },
];

export const jokerProGameCards = [
  {
    label: i18next.t("fourD_components.lucky_7"),
    icon: AssetsPack.icons.ICON_LUCKY7.default,
    isDisable: false,
  },
  {
    label: i18next.t("fourD_components.4d_lotto"),
    icon: AssetsPack.icons.ICON_4D.default,
    isDisable: false,
  },
  {
    label: i18next.t("fourD_components.all_games"),
    icon: AssetsPack.icons.ICON_ALL_GAMES.default,
    isDisable: true,
  },
];

export const jokerScratchGameCards = [
  {
    label: i18next.t("joker_scratch_page.sugar_scratch"),
    icon: AssetsPack.videos.SUGAR_LIST_INDICATOR,
    isDisable: false,
  },
  {
    label: i18next.t("joker_scratch_page.match_symbol"),
    icon: AssetsPack.videos.SUGAR_LIST_INDICATOR,
    isDisable: true,
  },
  {
    label: i18next.t("joker_scratch_page.turbo_scratch"),
    icon: AssetsPack.videos.SUGAR_LIST_INDICATOR,
    isDisable: false,
  },
  {
    label: i18next.t("joker_scratch_page.all_games"),
    icon: AssetsPack.videos.ALL_GAMES,
    isDisable: true,
  },
];

export const footerDataList: ListData[] = [
  {
    title: i18next.t("footer_section.4d"),
    list: [
      { name: i18next.t("footer_section.single"), url: "/joker_pro" },
      { name: i18next.t("footer_section.traditional"), url: "/joker_pro" },
      { name: i18next.t("footer_section.pro"), url: "/joker_pro" },
      { name: i18next.t("footer_section.package"), url: "/joker_pro" },
    ],
  },
  {
    title: i18next.t("footer_section.lucky_7"),
    list: [
      { name: i18next.t("footer_section.aus_4d"), url: "/joker_pro" },
      { name: i18next.t("footer_section.lucky_ball"), url: "/joker_pro" },
      { name: i18next.t("footer_section.three_ball"), url: "/joker_pro" },
      { name: i18next.t("footer_section.odds_events"), url: "/joker_pro" },
      { name: i18next.t("footer_section.miss_match"), url: "/joker_pro" },
    ],
  },
  {
    title: i18next.t("footer_section.scratch_and_win"),
    list: [
      {
        name: i18next.t("footer_section.turbo_scratch"),
        url: "/joker_scratch",
      },
      { name: i18next.t("footer_section.match_symbol"), url: "/joker_scratch" },
      {
        name: i18next.t("footer_section.sugar_scratch"),
        url: "/joker_scratch",
      },
      { name: i18next.t("footer_section.live_stream"), url: "/joker_scratch" },
    ],
  },
  {
    title: i18next.t("footer_section.customer_service"),
    list: [
      { name: i18next.t("footer_section.support"), url: "/support" },
      { name: i18next.t("footer_section.faq"), url: "/support" },
      { name: i18next.t("footer_section.contact_us"), url: "/support" },
      { name: i18next.t("footer_section.live_chat"), url: "/support" },
    ],
  },
];

export const sectionMainPageList = [
  {
    title: i18next.t("nav_bar.joker_pro"),
    description: i18next.t("fourD_components.components"),
    learnLink: "/joker_pro",
    downloadLink: "/downloadApk",
    overlayList: [
      { imageSrc: AssetsPack.image.BG_LUCKY_7 },
      { imageSrc: AssetsPack.videos.JOKER_PRO_HOME },
      { imageSrc: AssetsPack.image.BG_SLOTS },
    ],
    backgroundImg: AssetsPack.backgrounds.BG_MAIN_JOKER_PRO,
  },

  {
    title: i18next.t("nav_bar.joker_scratch"),
    description: i18next.t("main_section.joker_scratch"),
    learnLink: "/joker_scratch",
    downloadLink: "/downloadApk",
    overlayList: [
      { imageSrc: AssetsPack.image.BG_NEON_SCRATCH },
      { imageSrc: AssetsPack.videos.JOKER_TURBO_HOME },
      { imageSrc: AssetsPack.image.BG_SUGAR_SCRATCH },
    ],
    backgroundImg: AssetsPack.backgrounds.BG_MAIN_SCRATCH,
  },
];

export const rewardsRedeemCards = [
  {
    tagName: i18next.t("joker_rewards.redeem.share.tag"),
    title: i18next.t("joker_rewards.redeem.share.title"),
    description: i18next.t("joker_rewards.redeem.share.description"),
    image: AssetsPack.image.REFFERAL,
  },
  {
    tagName: i18next.t("joker_rewards.redeem.track.tag"),
    title: i18next.t("joker_rewards.redeem.track.title"),
    description: i18next.t("joker_rewards.redeem.track.description"),
    image: AssetsPack.image.GRAPH,
  },

  {
    tagName: i18next.t("joker_rewards.redeem.top_players.tag"),
    title: i18next.t("joker_rewards.redeem.top_players.title"),
    description: i18next.t("joker_rewards.redeem.top_players.description"),
    image: AssetsPack.image.CLIMB_RANK,
  },
  {
    tagName: i18next.t("joker_rewards.redeem.rewards.tag"),
    title: i18next.t("joker_rewards.redeem.rewards.title"),
    description: i18next.t("joker_rewards.redeem.rewards.description"),
    image: AssetsPack.image.UNLOCK_PERKS,
  },

  {
    tagName: i18next.t("joker_rewards.redeem.point_shop.tag"),
    title: i18next.t("joker_rewards.redeem.point_shop.title"),
    description: i18next.t("joker_rewards.redeem.point_shop.description"),
    image: AssetsPack.image.DOUBLE_POINTS,
  },
  {
    tagName: i18next.t("joker_rewards.redeem.perks.tag"),
    title: i18next.t("joker_rewards.redeem.perks.title"),
    description: i18next.t("joker_rewards.redeem.perks.description"),
    image: AssetsPack.image.REDEEM_REWARDS,
  },
];

export const lucky7GsapList = {
  overlayList: [
    { imageSrc: AssetsPack.image.JOKERPRO_LUCKY7_GSAP_1 },
    { imageSrc: AssetsPack.videos.JOKER_LUCKY7_GSAP },
    { imageSrc: AssetsPack.image.JOKERPRO_LUCKY7_GSAP_2 },
  ],
  backgroundImg: AssetsPack.image.JOKERPRO_LUCKY7_BG,
  infoList: [
    {
      title: i18next.t("joker_pro_page.lucky_7_gsap.section_1.title"),
      description: i18next.t(
        "joker_pro_page.lucky_7_gsap.section_1.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERPRO_LUCKY7_1.default,
    },

    {
      title: i18next.t("joker_pro_page.lucky_7_gsap.section_2.title"),
      description: i18next.t(
        "joker_pro_page.lucky_7_gsap.section_2.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERPRO_LUCKY7_2.default,
    },

    {
      title: i18next.t("joker_pro_page.lucky_7_gsap.section_2.title"),
      description: i18next.t(
        "joker_pro_page.lucky_7_gsap.section_3.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERPRO_LUCKY7_3.default,
    },
  ],
};

export const fourDGsapList = {
  overlayList: [
    { imageSrc: AssetsPack.image.JOKERPRO_LOTTO4D_GSAP_1 },
    { imageSrc: AssetsPack.videos.JOKER_LOTTO4D_GSAP },
    { imageSrc: AssetsPack.image.JOKERPRO_LOTTO4D_GSAP_2 },
  ],
  backgroundImg: AssetsPack.image.JOKERPRO_LOTTO4D_BG,
  infoList: [
    {
      title: i18next.t("joker_pro_page.lotto_4d_gsap.section_1.title"),
      description: i18next.t(
        "joker_pro_page.lotto_4d_gsap.section_1.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERPRO_LOTTO4D_1.default,
    },

    {
      title: i18next.t("joker_pro_page.lotto_4d_gsap.section_2.title"),
      description: i18next.t(
        "joker_pro_page.lotto_4d_gsap.section_2.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERPRO_LOTTO4D_2.default,
    },

    {
      title: i18next.t("joker_pro_page.lotto_4d_gsap.section_2.title"),
      description: i18next.t(
        "joker_pro_page.lotto_4d_gsap.section_3.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERPRO_LOTTO4D_3.default,
    },
  ],
};

export const turboGsapList = {
  overlayList: [
    { imageSrc: AssetsPack.image.JOKERPRO_TURBO_GSAP_1 },
    { imageSrc: AssetsPack.videos.JOKERPRO_TURBO_GSAP },
    { imageSrc: AssetsPack.image.JOKERPRO_TURBO_GSAP_2 },
  ],
  backgroundImg: AssetsPack.image.JOKERPRO_TURBO_BG,
  infoList: [
    {
      title: i18next.t("joker_scratch_page.turbo_gsap.section_1.title"),
      description: i18next.t(
        "joker_scratch_page.turbo_gsap.section_1.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERSCRATCH_TURBO_1.default,
    },

    {
      title: i18next.t("joker_scratch_page.turbo_gsap.section_2.title"),
      description: i18next.t(
        "joker_scratch_page.turbo_gsap.section_2.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERSCRATCH_TURBO_2.default,
    },

    {
      title: i18next.t("joker_scratch_page.turbo_gsap.section_3.title"),
      description: i18next.t(
        "joker_scratch_page.turbo_gsap.section_3.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERSCRATCH_TURBO_3.default,
    },
  ],
};

export const sugarGsapList = {
  overlayList: [
    { imageSrc: AssetsPack.image.JOKERPRO_SUGAR_GSAP_1 },
    { imageSrc: AssetsPack.image.JOKERPRO_SUGAR_GSAP_MIDDLE },
    { imageSrc: AssetsPack.image.JOKERPRO_SUGAR_GSAP_2 },
  ],
  backgroundImg: AssetsPack.image.JOKERPRO_SUGAR_BG,
  infoList: [
    {
      title: i18next.t("joker_scratch_page.sugar_gsap.section_1.title"),
      description: i18next.t(
        "joker_scratch_page.sugar_gsap.section_1.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERSCRATCH_SUGAR_1.default,
    },

    {
      title: i18next.t("joker_scratch_page.sugar_gsap.section_2.title"),
      description: i18next.t(
        "joker_scratch_page.sugar_gsap.section_2.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERSCRATCH_SUGAR_2.default,
    },

    {
      title: i18next.t("joker_scratch_page.sugar_gsap.section_3.title"),
      description: i18next.t(
        "joker_scratch_page.sugar_gsap.section_3.description"
      ),
      icon: AssetsPack.icons.ICON_JOKERSCRATCH_SUGAR_3.default,
    },
  ],
};
